import { useTranslation } from 'react-i18next';
import React from 'react';
import {
  MERGE_PRODUCT_DURATION,
  PACKAGE_DURATION_LABEL,
} from '@src/constants/package';

const TabDuration = ({
  percentage,
  packageDuration,
  handleChangePackageDuration,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tab-group-wrapper">
      {Object.values(MERGE_PRODUCT_DURATION).map((value) => (
        <div
          className={packageDuration === value ? `tabs-active` : `tabs`}
          onClick={() => handleChangePackageDuration(value)}
          role="button"
          tabIndex={0}
          data-id="select-pricing-duration"
          data-pricing-duration={value}
        >
          {t(PACKAGE_DURATION_LABEL[value])}
          {value !== MERGE_PRODUCT_DURATION.MONTHLY && !!percentage && (
            <div className="save">
              {t('discountPercent', {
                percent: percentage,
              }).toUpperCase()}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TabDuration;
